import React from 'react';
import { Button, Modal } from 'common/components';
import { XIcon } from '@fronton/icons-react';
import { reelModalModal, reelModalModalСlose, reelModalVideo } from './reel-modal-styles';
import { AdplatformTrainingReelStructure } from '../../adplatform-training-reels-section-constants';

type ReelModalProps = {
  onClose: () => void;
  show: boolean;
  activeReel: AdplatformTrainingReelStructure;
};

export const ReelModal: React.FC<ReelModalProps> = ({ onClose, show, activeReel }) => (
  <Modal variant="curtain" closeButton={false} className={reelModalModal} onClose={onClose} show={show}>
    <Button
      adaptive={false}
      size="s"
      className={reelModalModalСlose}
      iconOnly
      label="Close"
      rounded
      onClick={onClose}>
      <XIcon type="outline" size="m" color="text-invert" />
    </Button>
    {activeReel && (
      <video
        className={reelModalVideo}
        width="100%"
        height="446"
        title={activeReel.video?.alt}
        controls
        autoPlay>
        <track default kind="captions" srcLang="ru" src="" />
        <source src={activeReel.video?.src} type="video/mp4" />
      </video>
    )}
  </Modal>
);
